import React from 'react';
import { Link } from 'react-router-dom';

const StatsWidget = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  color = 'blue',
  iconColor, // Support both color and iconColor for backward compatibility
  link,
  trend,
  trendLabel
}) => {
  // Use iconColor if provided, otherwise use color
  const effectiveColor = iconColor || color;
  
  const colorClasses = {
    blue: {
      bg: 'bg-blue-100',
      icon: 'text-blue-600',
      value: 'text-blue-600',
      border: 'border-blue-200'
    },
    green: {
      bg: 'bg-green-100',
      icon: 'text-green-600',
      value: 'text-green-600',
      border: 'border-green-200'
    },
    purple: {
      bg: 'bg-purple-100',
      icon: 'text-purple-600',
      value: 'text-purple-600',
      border: 'border-purple-200'
    },
    orange: {
      bg: 'bg-orange-100',
      icon: 'text-orange-600',
      value: 'text-orange-600',
      border: 'border-orange-200'
    },
    red: {
      bg: 'bg-red-100',
      icon: 'text-red-600',
      value: 'text-red-600',
      border: 'border-red-200'
    },
    indigo: {
      bg: 'bg-indigo-100',
      icon: 'text-indigo-600',
      value: 'text-indigo-600',
      border: 'border-indigo-200'
    }
  };

  const colors = colorClasses[effectiveColor] || colorClasses.blue;

  const content = (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600">
            {title}
          </p>
          <p className={`text-3xl font-bold ${colors.value} mb-1`}>
            {value}
          </p>
          {subtitle && (
            <p className="text-xs text-gray-500">
              {subtitle}
            </p>
          )}
          {trend && (
            <div className="mt-2 flex items-center">
              <span className={`text-xs font-medium ${trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-600'}`}>
                {trend > 0 ? '↑' : trend < 0 ? '↓' : '→'} {Math.abs(trend)}%
              </span>
              {trendLabel && (
                <span className="text-xs text-gray-500">{trendLabel}</span>
              )}
            </div>
          )}
        </div>
        {Icon && (
          <div className={`${colors.bg} w-16 h-16 rounded-lg flex items-center justify-center`}>
            <Icon className={`h-8 w-8 ${colors.icon}`} />
          </div>
        )}
      </div>
    </div>
  );

  if (link) {
    return (
      <Link to={link} className="block">
        {content}
      </Link>
    );
  }

  return content;
};

export default StatsWidget;
